import React from "react";
import { useTranslation } from "react-i18next";

import AppRadioGroup from "../design-system/components/AppRadioGroup";
import "./AvailabilityModeRadioGroup.css";

export default function AvailabilityModeRadioGroup({
  value,
  onChange,
  name,
  disabled = false,
  includeCompanyDefault = false,
  selectionCards = false,
  className = "",
}) {
  const { t } = useTranslation();
  const options = [
    ...(includeCompanyDefault
      ? [{
          value: "",
          label: t("availability.user_settings.company_default", {
            defaultValue: "Unternehmensstandard",
          }),
        }]
      : []),
    {
      value: "absence",
      label: t("availability.settings_dialog.defaults.absence"),
      description: t("availability.settings_dialog.defaults.absence_description"),
    },
    {
      value: "availability",
      label: t("availability.settings_dialog.defaults.availability"),
      description: t("availability.settings_dialog.defaults.availability_description"),
    },
  ];

  return (
    <AppRadioGroup
      className={[
        "availability-mode-radio-group",
        selectionCards ? "availability-mode-radio-group--selection-cards" : "",
        className,
      ].filter(Boolean).join(" ")}
      direction="row"
      labelVariant="body-1"
      name={name}
      value={value}
      options={options}
      disabled={disabled}
      onChange={onChange}
    />
  );
}
